module.exports = __webpack_public_path__ + "media/vidos.07df56e2.mp4";